/**
 * ¿ESTE CONTACTO PUEDE FIGURAR COMO "SIN PAGO" EN COMISIONES?
 *
 * Ticket de Juan Carlos Salazar (Salazar Smart Group), 2026-09-29: *"algunos
 * contactos que están categorizados como Leads y Prospectos aparecen dentro de
 * la sección de Comisiones con el estado 'Sin pagos'. Estos contactos todavía
 * no son clientes y, por lo tanto, no deberían aparecer registrados como
 * comisiones pendientes o no pagadas."*
 *
 * El seguimiento de Comisiones arma su lista a partir de TODA la lista de
 * contactos, y a cada uno sin comisión en el período lo daba por "no pagó".
 * Ya dejaba fuera a los inactivos; los prospectos y los referidos se colaban.
 * Ninguno de los dos tiene póliza todavía, así que no hay comisión que esperar,
 * y la lista roja les decía a los agentes que la compañía les debía dinero.
 *
 * Se decide por el ESTADO de la ficha y solo para la lista de "no pagó". Si una
 * comisión SÍ llegó a nombre de un prospecto, esa fila se sigue enseñando en
 * "pagaron": el dinero está ahí, y esconderlo sería peor que el desorden de la
 * ficha.
 */
const NO_ESPERAN_COMISION = new Set(['inactive', 'prospect', 'referral']);

export function esperaComision(cliente) {
  const estado = String(cliente?.status || '').trim().toLowerCase();
  return !NO_ESPERAN_COMISION.has(estado);
}
